/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationState   from 'store/application';
import { resizeMixin }    from 'mixins';
import { getUniqueDomId } from 'utils/getUniqueDomId';

const Input = require('gui/inputs/input');

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'input-datetime-picker',

  mixins: [
    Input,
    resizeMixin
  ],

  data() {
    const uniqueValue = getUniqueDomId();
    return {
      widget_container: {
        top: 0,
        left: 0
      },
      iddatetimepicker: 'datetimepicker_' + uniqueValue,
      idinputdatetimepiker: 'inputdatetimepicker_' + uniqueValue,
    }
  },

  methods: {

    resize() {
      const domeDataPicker = $(`#${this.iddatetimepicker}`);
      if (domeDataPicker && domeDataPicker.data("DateTimePicker")) {
        domeDataPicker.data("DateTimePicker").hide();
      }
    },

    timeOnly () {
      return !this.state.input.options.formats[0].date;
    },

    /**
     * @since 3.8.0
     */
    onDatePickerChange() {
      const newDate = $(`#${this.idinputdatetimepiker}`).val();
      this.state.value =
        '' === newDate.trim()
          ? null
          : moment(newDate, this.datetimedisplayformat).format(this.datetimefieldformat);
      this.change();
    },

    /**
     * @fires datetimepickershow
     * 
     * @since 3.8.0
     */
    onDatePickerShow(evt) {
      // reset positions
      this.widget_container.top  = 0;
      this.widget_container.left = 0;
      // wait until widget is present in DOM  
      setTimeout(() => {
        const container            = this.$refs.datetimepicker_body.getBoundingClientRect();
        const modal                = this.$refs.datimewidget_container.querySelector('.bootstrap-datetimepicker-widget').getBoundingClientRect();
        this.widget_container.top  = container.top  + (container.top < modal.height ? container.height + Math.abs(container.top - modal.height) + 20 : 0); // 20 = padding
        this.widget_container.left = container.left - Math.max(container.width, modal.width);
        this.$emit('datetimepickershow');
      });
    },

    /**
     * @fires datetimepickershow
     * 
     * @since 3.8.0
     */
    onDatePickerHide(evt) {
      this.$emit('datetimepickershow');
    },

  },
  watch: {
    async 'state.value'(value) {
      // check if current value (state.value) is not equal to current wiget datetimepicker
      //means is changed by others (default expression evaluation for example)
      if (value !== $(`#${this.idinputdatetimepiker}`).val()) {
        const date = null !== value ? moment(value, this.datetimefieldformat).format(this.datetimedisplayformat) : value;
        await this.$nextTick();
        $(`#${this.idinputdatetimepiker}`).val(date);
      }
    }
  },

  async mounted() {
    const {
      formats = [],
      layout = {
        vertical: "top",
        horizontal: "left"
      }
    } = this.state.input.options;

    const {
      minDate,
      maxDate,
      fieldformat,
      enabledDates,
      disabledDates,
      displayformat,
      useCurrent
    } = formats[0];

    await this.$nextTick();

      // set has widget input property instance

    this.datetimedisplayformat = this.service.convertQGISDateTimeFormatToMoment(displayformat);
    this.datetimefieldformat = this.service.convertQGISDateTimeFormatToMoment(fieldformat);


    this.service.setValidatorOptions({ fielddatetimeformat: this.datetimefieldformat });

    const date =
      moment(this.state.value, this.datetimefieldformat, true).isValid()
        ? moment(this.state.value, this.datetimefieldformat).toDate()
        : null;


    $(`#${this.iddatetimepicker}`).datetimepicker({
      defaultDate: date,
      format: this.datetimedisplayformat,
      ignoreReadonly: true,
      allowInputToggle: true,
      enabledDates,
      disabledDates,
      useCurrent,
      toolbarPlacement: 'top',
      minDate,
      maxDate,
      widgetParent: $(this.$refs.datimewidget_container),
      widgetPositioning: {
        vertical: layout.vertical || 'top',
        horizontal: layout.horizontal || 'left'
      },
      showClose: true,
      locale: this.service.getLocale()
    });

    $(`#${this.iddatetimepicker}`).on("dp.change", this.onDatePickerChange);
    $(`#${this.iddatetimepicker}`).on("dp.show", this.onDatePickerShow);
    $(`#${this.iddatetimepicker}`).on("dp.hide", this.onDatePickerHide);

    if (ApplicationState.ismobile) {
      setTimeout(() => { $(`#${this.idinputdatetimepiker}`).blur(); });
    }

  }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{ref:"datetimepicker_body",attrs:{"slot":"body"},slot:"body"},[_c('div',{ref:"datimewidget_container",style:({
        top: _vm.widget_container.top + 'px',
        left: _vm.widget_container.left + 'px',
        position: 'fixed',
        zIndex: 10000,
      })}),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],staticClass:"input-group date",attrs:{"id":_vm.iddatetimepicker}},[_c('input',{staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},attrs:{"type":"text","id":_vm.idinputdatetimepiker,"tabIndex":_vm.tabIndex,"readonly":!_vm.editable || _vm.isMobile() ? 'readonly' : null}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon caret"},[_c('span',{class:[ _vm.g3wtemplate.getFontClass(_vm.timeOnly() ? 'time' : 'calendar') ]})])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputDateTimePicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__